module.exports = __webpack_public_path__ + "static/img/admin.b11c4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/admin.png
// module id = 405
// module chunks = 2